const DEFAULT_HAS_LAST_TABLE = false;

export default DEFAULT_HAS_LAST_TABLE;
